/**
 * Ступень линии: значение действует с start по end.
 * end === null — действует до правого края графика.
 * Если end ступени совпадает со start следующей, ступени соединяются вертикалью.
 */
class ChartStep {
  readonly start: Date;

  readonly end: Date | null;

  readonly value: number;

  readonly title: string;

  constructor(start: Date, end: Date | null, value: number, title: string) {
    this.start = start;
    this.end = end;
    this.value = value;
    this.title = title;
  }
}

export default ChartStep;
